import PocketBase from 'pocketbase';

// Utilisation des variables d'environnement avec une valeur par défaut
const POCKETBASE_URL = process.env.REACT_APP_POCKETBASE_URL;
export const pb = new PocketBase(POCKETBASE_URL);

// Fonction pour se connecter et récupérer les informations de l'étudiant
export const login = async (email, password) => {
  try {
    // Authentification de l'utilisateur
    const authData = await pb.collection('users').authWithPassword(email, password);
    const user = authData.record;
    
    // Récupération de l'étudiant associé si disponible
    let student = null;
    
    if (user.student_id) {
      try {
        // Récupérer l'étudiant directement avec les relations
        student = await pb.collection('students').getOne(user.student_id, {
          expand: 'formation,company,contract_id'
        });
      } catch (studentError) {
        console.error('Erreur lors de la récupération de l\'étudiant:', studentError);
      }
    } else {
      // Essayer de trouver l'étudiant par user_ref
      try {
        student = await pb.collection('students').getFirstListItem(`user_ref="${user.id}"`, {
          expand: 'formation,company,contract_id'
        });
      } catch (studentError) {
        console.error('Aucun étudiant associé à cet utilisateur');
      }
    }
    
    return {
      success: true,
      user: user,
      student: student,
      token: pb.authStore.token
    };
  } catch (error) {
    console.error('Erreur de connexion:', error);
    return {
      success: false,
      message: error.message || 'Échec de la connexion'
    };
  }
};

// Fonction pour se déconnecter
export const logout = () => {
  pb.authStore.clear();
};

// Fonction pour vérifier si l'utilisateur est connecté
export const isAuthenticated = () => {
  return pb.authStore.isValid;
};

// Fonction pour récupérer l'utilisateur actuel
export const getCurrentUser = () => {
  return pb.authStore.model;
};

// Fonction pour vérifier si l'utilisateur a un rôle spécifique
export const hasRole = (role) => {
  const user = getCurrentUser();
  if (!user || !user.role) return false;
  return user.role.includes(role);
};

// Vérifier si l'utilisateur est admin
export const isAdmin = () => {
  return hasRole('Admin');
};

// Vérifier si l'utilisateur est étudiant
export const isStudent = () => {
  return hasRole('Student');
};

// Vérifier si l'utilisateur est une entreprise
export const isCompany = () => {
  return hasRole('Company');
};

// Vérifier si l'utilisateur est SuperAdmin
export const isSuperAdmin = () => {
  return hasRole('SuperAdmin');
};

// Vérifier si l'utilisateur est Commercial
export const isCommercial = () => {
  return hasRole('Commercial');
};

// Vérifier si l'utilisateur est Pedagogical
export const isPedagogical = () => {
  return hasRole('Pedagogical');
};

// Vérifier si l'utilisateur est enseignant
export const isTeacher = () => {
  return hasRole('Teacher');
};

